import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import AuthOtpInputView from './auth-otp-input.component.html';

@Component({
    selector: 'auth-otp-input',
    template: AuthOtpInputView
})
export class AuthOtpInputComponent implements OnInit, OnChanges {

    @Input() value: string = '';
    @Output() valueChange = new EventEmitter<string>();

    code: string = '';

    ngOnInit(): void {
        // Always start empty regardless of incoming value binding
        this.code = '';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['value'] && !changes['value'].isFirstChange() && changes['value'].currentValue !== this.code) {
            this.code = changes['value'].currentValue || '';
        }
    }

    onCodeChange(newValue: string): void {
        this.code = newValue || '';
        this.valueChange.emit(this.code);
    }
}
